import Phaser from 'phaser';
import { StickFigureGraphics } from '../rendering/StickFigureGraphics';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    this.load.image('builder_idle_v3', '/assets/builder_idle_v3.png');
    this.load.image('builder_hammering_v3', '/assets/builder_hammering_v3.png');
  }

  create(): void {
    StickFigureGraphics.bakeTextures(this);
    this.scene.start('GameScene');
  }
}
